module.exports = __webpack_public_path__ + "img/joinStraight2.96dbc316.svg";